import { Fragment } from "@wordpress/element";
import { PanelBody, RadioControl, ToggleControl } from "@wordpress/components";
import { __ } from "@wordpress/i18n";

const MeetTheTeamDetails = props => {
  const { setAttributes } = props;

  const {
    hideTitleCard,
    imageAspectRatio,
    displayNameAndJobTitle,
    displayBio
  } = props.attributes;

  const aspectRatioOptions = [
    { label: "Square", value: "square" },
    { label: "Rectangular", value: "rectangular" }
  ];

  const displayNameAndJobTitleOptions = [
    { label: "Within Image", value: "inside" },
    { label: "Below Image", value: "below" }
  ];

  const displayBioOptions = [
    { label: "On Hover", value: "hover" },
    { label: "In Modal", value: "modal" }
  ];

  return (
    <Fragment>
      <PanelBody
        className="display-options"
        title={ __("Display Options") }
      >
        <ToggleControl
          label={ __("Hide Title Card") }
          checked={ hideTitleCard }
          onChange={ hideTitleCard => setAttributes({ hideTitleCard }) }
        />
        <RadioControl
          label={ __("Image Aspect Ratio") }
          options={ aspectRatioOptions }
          selected={ imageAspectRatio }
          onChange={ imageAspectRatio => setAttributes({ imageAspectRatio }) }
        />
        <RadioControl
          label={ __("Display Name and Job Title") }
          options={ displayNameAndJobTitleOptions }
          selected={ displayNameAndJobTitle }
          onChange={ displayNameAndJobTitle => setAttributes({ displayNameAndJobTitle }) }
        />
        <RadioControl
          label={ __("Display Bio") }
          options={ displayBioOptions }
          selected={ displayBio }
          onChange={ displayBio => setAttributes({ displayBio }) }
        />
      </PanelBody>
    </Fragment>
  )
}

export default MeetTheTeamDetails;
